import http from './ajax';

const API_URL = {
  Activities: '/api/Activities', //投稿清單
  ActivityDetail: '/api/Activity', //詳細
  SubmitActivity: '/api/Activity/Submit', //報名活動
  ActivityCategory: '/api/Activity/Category', //活動分類項目
  Albums: '/api/Albums', //活動剪影清單
  AlbumDetail: '/api/Album' //活動剪影詳細
};

class ActivityApi extends http {
  //活動清單
  ActivityList = async (params = {}) => {
    try {
      let url = `${API_URL.Activities}${params.id ? '/' + params.id : ''}?page=${params.page}&count=${params.count}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('Activity', err);
    }
  };

  getActivityList = (params = {}) => {
    return this.ActivityList(params);
  };

  //月份取活動列表
  ActivityListMonth = async (params = {}) => {
    try {
      let url = `${API_URL.Activities}/${params.Month}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('ActivityListMonth', err);
    }
  };

  getActivityListMonth = (params = {}) => {
    return this.ActivityListMonth(params);
  };

  //分類項目
  ActivityCategory = async () => {
    try {
      let url = API_URL.ActivityCategory;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('ActivityCategory', err);
    }
  };

  getActivityCategory = () => {
    return this.ActivityCategory();
  };

  //活動詳細
  ActivityDetail = async (params = {}) => {
    try {
      let url = `${API_URL.ActivityDetail}/${params.Id}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('ActivityDetail', err);
    }
  };

  getActivityDetail = (params = {}) => {
    return this.ActivityDetail(params);
  };

  //活動報名
  SubmitActivity = async (params = {}) => {
    try {
      let url = API_URL.SubmitActivity;
      const response = await this.postRequest(url, params);
      return response;
    } catch (err) {
      console.log('SubmitActivity', err);
    }
  };

  getSubmitActivity = (params = {}) => {
    return this.SubmitActivity(params);
  };

  //活動剪影清單
  AlbumList = async (params = {}) => {
    try {
      let url = `${API_URL.Albums}?page=${params.page}&count=${params.count}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('AlbumList', err);
    }
  };

  getAlbumList = (params = {}) => {
    return this.AlbumList(params);
  };

  //活動剪影詳細
  AlbumDetail = async (params = {}) => {
    try {
      let url = `${API_URL.AlbumDetail}/${params.Id}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('AlbumDetail', err);
    }
  };

  getAlbumDetail = (params = {}) => {
    return this.AlbumDetail(params);
  };
}

export default new ActivityApi();



// WEBPACK FOOTER //
// ./src/service/activity.js